import { Box, css, mixins, styled } from '@creditas-ui/react';

export const scrollBar = css`
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar-thumb {
    height: 68px;
    display: none;
    transition-delay: 250ms;
  }
  :hover {
    &::-webkit-scrollbar-thumb {
      display: block;
    }
  }
`;

export const ScrollBox = styled(Box)`
  padding: 0;
  height: calc(100% - 100px);
  ${mixins.scrollBar};
  ${scrollBar};
`;
